import { useReturnToPrevious } from "../misc/useReturnToPrevious";
import { useIsMobile } from "@/hooks/use-mobile";
import { CompanyList } from "./CompanyList";
import { MobileCompanyList } from "./MobileCompanyList";
import { CompanyCreateSheet } from "./CompanyCreateSheet";
export const CompanyCreate = () => {
  const goBack = useReturnToPrevious("/companies");
  const mobile = useIsMobile();
  return (
    <>
      {mobile ? <MobileCompanyList /> : <CompanyList />}
      <CompanyCreateSheet
        open
        onOpenChange={(open) => {
          if (!open) goBack();
        }}
      />
    </>
  );
};
